
export default class Print {
  constructor(el) {
    el.addEventListener('click', function(){
      window.print();
    });
  }
}
